module.exports = __webpack_public_path__ + "static/img/4.3c0c009.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4.gif
// module id = InA1
// module chunks = 13